const tokenReducer = (state = '',action) => {
    switch(action.type){
        case "SAVETOKEN":
            return state = action.payload
        case "REMOVETOKEN":
            return state = ''
         default:
             return state
    } 
}

export default tokenReducer;

